import React, { useEffect, useRef, useState } from "react";
import { Image as ImageIcon, Camera } from "lucide-react";
import useImagePicker from "./useImagePicker";

// Round camera button for the chat footer that opens an "Upload image / Take photo" menu and hands the picked File to onImageSelected.
function AttachImageButton({ onImageSelected, disabled }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuContainerRef = useRef(null);
  const { openGalleryPicker, openCamera, pickerElements } = useImagePicker(onImageSelected);

  // Closes the attach menu when the user clicks anywhere outside it.
  useEffect(() => {
    if (!isMenuOpen) return;
    const closeMenuOnOutsideClick = (event) => {
      if (menuContainerRef.current && !menuContainerRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", closeMenuOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeMenuOnOutsideClick);
  }, [isMenuOpen]);

  return (
    <div ref={menuContainerRef} className="krunk-relative krunk-flex krunk-items-center krunk-flex-shrink-0">
      <button
        type="button"
        onClick={() => setIsMenuOpen((open) => !open)}
        disabled={disabled}
        aria-label="Attach a photo"
        title="Attach a photo"
        className="krunk-flex krunk-items-center krunk-justify-center krunk-w-10 krunk-h-10 krunk-rounded-full krunk-bg-buttonbackground krunk-text-white krunk-transition-opacity hover:krunk-opacity-90 disabled:krunk-opacity-50"
      >
        <Camera className="krunk-w-5 krunk-h-5" />
      </button>

      {isMenuOpen && (
        <div className="krunk-absolute krunk-bottom-12 krunk-right-0 krunk-z-50 krunk-bg-white krunk-rounded-xl krunk-shadow-lg krunk-border krunk-border-gray-100 krunk-py-1 krunk-w-44">
          <button
            type="button"
            onClick={() => { setIsMenuOpen(false); openGalleryPicker(); }}
            className="krunk-flex krunk-items-center krunk-gap-2 krunk-w-full krunk-px-3 krunk-py-2 krunk-text-sm krunk-text-black hover:krunk-bg-gray-100"
          >
            <ImageIcon className="krunk-w-4 krunk-h-4" />
            Upload a photo
          </button>
          <button
            type="button"
            onClick={() => { setIsMenuOpen(false); openCamera(); }}
            className="krunk-flex krunk-items-center krunk-gap-2 krunk-w-full krunk-px-3 krunk-py-2 krunk-text-sm krunk-text-black hover:krunk-bg-gray-100"
          >
            <Camera className="krunk-w-4 krunk-h-4" />
            Take a photo
          </button>
        </div>
      )}

      {pickerElements}
    </div>
  );
}

export default AttachImageButton;
